exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "#view {\n  margin-top: 70px;\n  padding: 10px 20px; }\n\n@media (min-width: 768px) {\n  #view {\n    margin-top: 70px;\n    margin-left: 315px;\n    padding: 10px 20px; } }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./src/App.scss
// module id = 1068
// module chunks = 0